// routes.js
import { jwtDecode } from "jwt-decode";

/**
 * ROTAS
 */
export const Routes = {
    // Públicas
    Presentation: { path: "/" },
    Connect: { path: "/connect" },

    // Connect (Login/Register + Dashboards)
    Signin: { path: "/connect/login" },
    Signup: { path: "/connect/register" },
    ForgotPassword: { path: "/connect/forgot-password" },
    ResetPassword: { path: "/connect/reset-password" },
    NotFound: { path: "/connect/404" },

    // Perfil
    Perfil: { path: "/connect/perfil" },

    // Admin / Staff
    dashboardAdmin: { path: "/connect/dashboard/admin" },
    Praticantes: { path: "/connect/praticantes/admin" },
    Turmas: { path: "/connect/turmas/admin" },
    Aulas: { path: "/connect/aulas/admin" },
    Eventos: { path: "/connect/eventos/admin" },
    Pagamentos: { path: "/connect/pagamentos/admin" },
    Utilizadores: { path: "/connect/utilizadores/admin" },
    Mensagens: { path: "/connect/mensagens/admin" },

    // User
    dashboardUser: { path: "/connect/dashboard/user" },
    PraticantesUser: { path: "/connect/praticantes/user" },
    AulasUser: { path: "/connect/aulas/user" },
    EventosUser: { path: "/connect/eventos/user" },
    PagamentosUser: { path: "/connect/pagamentos/user" },
    MensagensUser: { path: "/connect/mensagens/user" },
};

/**
 * PERMISSÕES
 */
export const routePermissions = {
    // Admin / Staff
    [Routes.dashboardAdmin.path]: { roles: ["admin", "treinador", "tesoureiro"] },
    [Routes.Praticantes.path]: { roles: ["admin", "treinador", "tesoureiro"] },
    [Routes.Turmas.path]: { roles: ["admin", "treinador"] },
    [Routes.Aulas.path]: { roles: ["admin", "treinador"] },
    [Routes.Eventos.path]: { roles: ["admin", "treinador"] },
    [Routes.Pagamentos.path]: { roles: ["admin", "tesoureiro"] },
    [Routes.Utilizadores.path]: { roles: ["admin"] },
    [Routes.Mensagens.path]: { roles: ["admin", "treinador", "tesoureiro"] },

    // User
    [Routes.dashboardUser.path]: { roles: ["user"], requiresActive: true },
    [Routes.AulasUser.path]: { roles: ["user"], requiresActive: true },
    [Routes.EventosUser.path]: { roles: ["user"], requiresActive: true },
    [Routes.PagamentosUser.path]: { roles: ["user"], requiresActive: true },
    [Routes.PraticantesUser.path]: { roles: ["user"] },
    [Routes.MensagensUser.path]: { roles: ["user"], requiresActive: true },

    // Perfil
    [Routes.Perfil.path]: { roles: ["admin", "treinador", "tesoureiro", "user"] },
    [Routes.ResetPassword.path]: { roles: ["admin", "treinador", "tesoureiro", "user"] },
    [Routes.Perfil.NotFound]: { roles: ["admin", "treinador", "tesoureiro", "user"] }
};

/**
 * Função para verificar se o utilizador pode aceder à rota
 */
export function canAccessRoute(path) {
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");
    if (!token) return false;

    try {
        const decoded = jwtDecode(token);
        const role = decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]?.toLowerCase();
        const isAtivo = decoded["isAtivo"] === "1";
        const rule = routePermissions[path];

        if (!rule) return true; // rota pública
        if (!rule.roles.includes(role)) return false;
        if (rule.requiresActive && !isAtivo) return false;

        return true;
    } catch {
        return false;
    }
}
